(() => {
  'use strict';

  const updateHeaderHeight = () => {
    const header = document.querySelector('.sst-header-section') || document.querySelector('.shopify-section-header');
    if (!header) return;
    document.documentElement.style.setProperty(
      '--sst-header-height',
      `${Math.round(header.getBoundingClientRect().height)}px`,
    );
  };

  const setupAnnouncements = (scope) => {
    scope.querySelectorAll('[data-sst-announcement]').forEach((bar) => {
      if (bar.dataset.sstReady) return;
      bar.dataset.sstReady = 'true';

      const items = [...bar.querySelectorAll('[data-sst-announcement-item]')];
      if (items.length < 2 || bar.dataset.autoRotate !== 'true') return;

      let activeIndex = 0;
      let timer;
      const interval = Math.max(Number.parseInt(bar.dataset.interval, 10) || 5000, 3000);
      const show = (index) => {
        items.forEach((item, itemIndex) => {
          const isActive = itemIndex === index;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-hidden', String(!isActive));
        });
      };
      const start = () => {
        window.clearInterval(timer);
        timer = window.setInterval(() => {
          activeIndex = (activeIndex + 1) % items.length;
          show(activeIndex);
        }, interval);
      };

      bar.addEventListener('mouseenter', () => window.clearInterval(timer));
      bar.addEventListener('mouseleave', start);
      bar.addEventListener('focusin', () => window.clearInterval(timer));
      bar.addEventListener('focusout', start);
      start();
    });
  };

  const setupHeader = (scope) => {
    scope.querySelectorAll('[data-sst-header]').forEach((header) => {
      if (header.dataset.sstReady) return;
      header.dataset.sstReady = 'true';

      const megaMenus = [...header.querySelectorAll('[data-sst-mega]')];
      const closeOthers = (current) => {
        megaMenus.forEach((menu) => {
          if (menu !== current) menu.removeAttribute('open');
        });
      };

      megaMenus.forEach((menu) => {
        let closeTimer;
        const trigger = menu.querySelector('[data-sst-menu-url]');
        const open = () => {
          window.clearTimeout(closeTimer);
          closeOthers(menu);
          menu.setAttribute('open', '');
        };
        const close = () => {
          closeTimer = window.setTimeout(() => menu.removeAttribute('open'), 140);
        };

        menu.addEventListener('pointerenter', open);
        menu.addEventListener('pointerleave', close);
        menu.addEventListener('focusin', open);
        menu.addEventListener('focusout', (event) => {
          if (!menu.contains(event.relatedTarget)) close();
        });

        trigger?.addEventListener('click', (event) => {
          if (!window.matchMedia('(min-width: 990px)').matches) return;
          const destination = trigger.dataset.sstMenuUrl;
          if (!destination) return;
          event.preventDefault();
          window.location.assign(destination);
        });
      });

      header.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        megaMenus.forEach((menu) => menu.removeAttribute('open'));
        header.querySelectorAll('[data-sst-mobile-menu][open]').forEach((item) => {
          item.removeAttribute('open');
        });
        // The search modal manages focus trapping and body scroll, so let it close itself.
        header.querySelectorAll('[data-sst-search]').forEach((search) => {
          if (search.querySelector('details[open]')) search.close?.();
        });
      });

      header.querySelectorAll('[data-sst-menu-close]').forEach((button) => {
        button.addEventListener('click', () => button.closest('[data-sst-mobile-menu]')?.removeAttribute('open'));
      });
    });
  };

  const enhance = (scope = document) => {
    document.documentElement.classList.add('sst-enhanced');
    updateHeaderHeight();
    setupAnnouncements(scope);
    setupHeader(scope);

    scope
      .querySelectorAll('.card__media img, .product__media img, .article-template__hero-container img')
      .forEach((image) => {
        const reveal = () => image.closest('.media')?.classList.add('sst-media-loaded');
        if (image.complete) reveal();
        else image.addEventListener('load', reveal, { once: true });
      });

    scope.querySelectorAll('a[href^="#"]:not([href="#"])').forEach((link) => {
      if (link.dataset.sstAnchorReady) return;
      link.dataset.sstAnchorReady = 'true';
      link.addEventListener('click', (event) => {
        const target = document.querySelector(link.hash);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start',
        });
        target.focus({ preventScroll: true });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => enhance(), { once: true });
  } else {
    enhance();
  }

  window.addEventListener('resize', updateHeaderHeight, { passive: true });
  document.addEventListener('shopify:section:load', (event) => enhance(event.target));
})();
